// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── ClosingHoldModal – modern card design ────────────────────────────── */
.chm-container {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: min(440px, 92vw);
  border-radius: 16px;
  background: #ffffff;
  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18), 0 4px 16px rgba(0, 0, 0, 0.08);
  overflow: hidden;
  color: #1a1d2e;
}

.dark .chm-container {
  background: #1e2130;
  color: #e8eaf6;
}

/* ── Header ─────────────────────────────────────────────────────────── */
.chm-header {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 20px 20px 16px;
}

.chm-icon-badge {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: #fff3e0;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.chm-header-text {
  flex: 1;
  min-width: 0;
}

.chm-title {
  font-size: 1rem;
  font-weight: 700;
  margin: 0 0 3px;
  color: #1a1d2e;
  line-height: 1.3;
}
.dark .chm-title {
  color: #e8eaf6;
}

.chm-subtitle {
  font-size: 0.78rem;
  color: #6b7280;
  margin: 0;
  line-height: 1.4;
}

.chm-close-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: #9ca3af;
  width: 30px;
  height: 30px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  transition: background 0.15s, color 0.15s;
  padding: 0;
}
.chm-close-btn:hover {
  background: #f3f4f6;
  color: #374151;
}

.chm-divider-line {
  height: 1px;
  background: #f0f0f4;
  margin: 0 20px;
}

/* ── Body ───────────────────────────────────────────────────────────── */
.chm-body {
  padding: 16px 20px 22px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}

.chm-description {
  font-size: 0.83rem;
  color: #6b7280;
  line-height: 1.6;
  margin: 0;
}

/* ── Action row (two side-by-side outline buttons) ──────────────────── */
.chm-action-row {
  display: flex;
  gap: 10px;
}

/* ── Buttons ────────────────────────────────────────────────────────── */
.chm-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  border-radius: 10px;
  font-size: 0.78rem;
  font-weight: 600;
  cursor: pointer;
  padding: 10px 14px;
  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s, transform 0.12s;
  border: 1.5px solid transparent;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
  line-height: 1;
}

.chm-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
  transform: none !important;
}

.chm-btn--outline-blue {
  flex: 1;
  background: #eff6ff;
  border-color: #bfdbfe;
  color: #1d4ed8;
}
.chm-btn--outline-blue:hover:not(:disabled) {
  background: #dbeafe;
  border-color: #93c5fd;
  transform: translateY(-1px);
}

.chm-btn--outline-red {
  flex: 1;
  background: #fff1f2;
  border-color: #fecdd3;
  color: #be123c;
}
.chm-btn--outline-red:hover:not(:disabled) {
  background: #ffe4e6;
  border-color: #fda4af;
  transform: translateY(-1px);
}

.chm-btn--primary {
  width: 100%;
  background: #1d4ed8;
  border-color: #1d4ed8;
  color: #ffffff;
}
.chm-btn--primary:hover:not(:disabled) {
  background: #1e40af;
  border-color: #1e40af;
  box-shadow: 0 4px 16px rgba(29, 78, 216, 0.28);
  transform: translateY(-1px);
}

/* ── OR divider ─────────────────────────────────────────────────────── */
.chm-or-divider {
  display: flex;
  align-items: center;
  gap: 10px;
}

.chm-or-line {
  flex: 1;
  height: 1px;
  background: #e5e7eb;
  display: block;
}

.chm-or-text {
  font-size: 0.72rem;
  color: #9ca3af;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

/* ── Mobile ─────────────────────────────────────────────────────────── */
@media (max-width: 576px) {
  .chm-container {
    width: 100%;
    top: auto;
    bottom: 0;
    left: 0;
    right: 0;
    transform: none;
    border-radius: 16px 16px 0 0;
  }
  .chm-action-row {
    flex-direction: column;
  }
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/ClosingHoldModal/ClosingHoldModal.css"],"names":[],"mappings":"AAAA,4EAA4E;AAC5E;EACE,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;EACnB,2EAA2E;EAC3E,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;EACd,yCAAyC;EACzC,UAAU;AACZ;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0EAA0E;AAC1E;EACE,uBAAuB;EACvB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,SAAS;AACX;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,SAAS;AACX;;AAEA,0EAA0E;AAC1E;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,mFAAmF;EACnF,+BAA+B;EAC/B,yBAAyB;EACzB,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,0BAA0B;AAC5B;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,OAAO;EACP,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;EAC9C,2BAA2B;AAC7B;;AAEA,0EAA0E;AAC1E;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,OAAO;EACP,WAAW;EACX,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA,0EAA0E;AAC1E;EACE;IACE,WAAW;IACX,SAAS;IACT,SAAS;IACT,OAAO;IACP,QAAQ;IACR,eAAe;IACf,4BAA4B;EAC9B;EACA;IACE,sBAAsB;EACxB;AACF","sourcesContent":["/* ── ClosingHoldModal – modern card design ────────────────────────────── */\n.chm-container {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: min(440px, 92vw);\n  border-radius: 16px;\n  background: #ffffff;\n  box-shadow: 0 24px 64px rgba(0, 0, 0, 0.18), 0 4px 16px rgba(0, 0, 0, 0.08);\n  overflow: hidden;\n  color: #1a1d2e;\n}\n\n.dark .chm-container {\n  background: #1e2130;\n  color: #e8eaf6;\n}\n\n/* ── Header ─────────────────────────────────────────────────────────── */\n.chm-header {\n  display: flex;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 20px 20px 16px;\n}\n\n.chm-icon-badge {\n  width: 44px;\n  height: 44px;\n  border-radius: 12px;\n  background: #fff3e0;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.chm-header-text {\n  flex: 1;\n  min-width: 0;\n}\n\n.chm-title {\n  font-size: 1rem;\n  font-weight: 700;\n  margin: 0 0 3px;\n  color: #1a1d2e;\n  line-height: 1.3;\n}\n.dark .chm-title {\n  color: #e8eaf6;\n}\n\n.chm-subtitle {\n  font-size: 0.78rem;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.4;\n}\n\n.chm-close-btn {\n  background: none;\n  border: none;\n  cursor: pointer;\n  color: #9ca3af;\n  width: 30px;\n  height: 30px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n  transition: background 0.15s, color 0.15s;\n  padding: 0;\n}\n.chm-close-btn:hover {\n  background: #f3f4f6;\n  color: #374151;\n}\n\n.chm-divider-line {\n  height: 1px;\n  background: #f0f0f4;\n  margin: 0 20px;\n}\n\n/* ── Body ───────────────────────────────────────────────────────────── */\n.chm-body {\n  padding: 16px 20px 22px;\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.chm-description {\n  font-size: 0.83rem;\n  color: #6b7280;\n  line-height: 1.6;\n  margin: 0;\n}\n\n/* ── Action row (two side-by-side outline buttons) ──────────────────── */\n.chm-action-row {\n  display: flex;\n  gap: 10px;\n}\n\n/* ── Buttons ────────────────────────────────────────────────────────── */\n.chm-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  border-radius: 10px;\n  font-size: 0.78rem;\n  font-weight: 600;\n  cursor: pointer;\n  padding: 10px 14px;\n  transition: background 0.15s, border-color 0.15s, box-shadow 0.15s, transform 0.12s;\n  border: 1.5px solid transparent;\n  text-transform: uppercase;\n  letter-spacing: 0.4px;\n  white-space: nowrap;\n  line-height: 1;\n}\n\n.chm-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n  transform: none !important;\n}\n\n.chm-btn--outline-blue {\n  flex: 1;\n  background: #eff6ff;\n  border-color: #bfdbfe;\n  color: #1d4ed8;\n}\n.chm-btn--outline-blue:hover:not(:disabled) {\n  background: #dbeafe;\n  border-color: #93c5fd;\n  transform: translateY(-1px);\n}\n\n.chm-btn--outline-red {\n  flex: 1;\n  background: #fff1f2;\n  border-color: #fecdd3;\n  color: #be123c;\n}\n.chm-btn--outline-red:hover:not(:disabled) {\n  background: #ffe4e6;\n  border-color: #fda4af;\n  transform: translateY(-1px);\n}\n\n.chm-btn--primary {\n  width: 100%;\n  background: #1d4ed8;\n  border-color: #1d4ed8;\n  color: #ffffff;\n}\n.chm-btn--primary:hover:not(:disabled) {\n  background: #1e40af;\n  border-color: #1e40af;\n  box-shadow: 0 4px 16px rgba(29, 78, 216, 0.28);\n  transform: translateY(-1px);\n}\n\n/* ── OR divider ─────────────────────────────────────────────────────── */\n.chm-or-divider {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.chm-or-line {\n  flex: 1;\n  height: 1px;\n  background: #e5e7eb;\n  display: block;\n}\n\n.chm-or-text {\n  font-size: 0.72rem;\n  color: #9ca3af;\n  font-weight: 600;\n  text-transform: uppercase;\n  letter-spacing: 0.6px;\n}\n\n/* ── Mobile ─────────────────────────────────────────────────────────── */\n@media (max-width: 576px) {\n  .chm-container {\n    width: 100%;\n    top: auto;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    transform: none;\n    border-radius: 16px 16px 0 0;\n  }\n  .chm-action-row {\n    flex-direction: column;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
